import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { _className, ComponentSync, Grid, LL_H_C, TS_Checkbox, TS_CollapsableContainerV2 } from '@nu-art/thunderstorm-frontend/index';
import './Component_SmartNoteSection.scss';
import { ICONS } from '@app/styles';
import { DefaultEditor_TextArea } from '@app/styles/frontend/ui-manager/ui-components';
import { ColumnKey_MiddleColumn } from '../../../_shared.js';
import { exists } from '@nu-art/ts-common';
export class Component_SmartNoteSection extends ComponentSync {
    textAreaRef = React.createRef();
    //######################### Life Cycle #########################
    __onAdvisorBoardTransitionEnd = (columnKey) => {
        if (columnKey === ColumnKey_MiddleColumn && this.state.editMode) {
            this.textAreaRef.current?.resizeWithText();
        }
    };
    deriveStateFromProps(nextProps, state) {
        state.section = nextProps.section;
        state.editMode = nextProps.editMode;
        state.aiMode = nextProps.aiMode;
        state.parentDisabled = !!nextProps.parentDisabled;
        state.collapsed ??= !state.section.item.isSelected;
        return state;
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.aiMode !== this.state.aiMode) {
            this.textAreaRef.current?.resizeWithText();
        }
    }
    //######################### Logic #########################
    getClassName = () => {
        const section = this.state.section.item;
        return _className('smart-note-section', section.indent && 'indent', !section.isSelected && 'not-selected');
    };
    renderAsSelectableTextArea = () => {
        const section = this.state.section.item;
        return !section.title?.length && !section.subSections?.length;
    };
    toggleSectionSelection = () => {
        const section = this.state.section;
        const newSelectionState = !section.item.isSelected;
        if (this.state.collapsed === newSelectionState)
            this.setState({ collapsed: !newSelectionState }, () => section.updateObj({ isSelected: newSelectionState }));
        else
            section.updateObj({ isSelected: newSelectionState });
    };
    //######################### Render #########################
    render() {
        const className = this.getClassName();
        if (this.renderAsSelectableTextArea())
            return _jsxs(LL_H_C, { className: className, children: [this.render_SectionContent(), this.render_Checkbox()] });
        return _jsx(TS_CollapsableContainerV2, { headerRenderer: this.render_Header(), containerRenderer: this.render_Body(), className: className, collapsed: this.state.collapsed, onCollapseToggle: () => this.setState({ collapsed: !this.state.collapsed }), forceUpdate: true, animated: true });
    }
    render_Header = () => {
        const section = this.state.section.item;
        if (section.title?.length)
            return _jsxs(_Fragment, { children: [_jsx("div", { className: 'smart-note-section__title', children: section.title }), this.render_Checkbox()] });
        return _jsxs(_Fragment, { children: [this.render_SectionContent(), this.render_Checkbox()] });
    };
    render_Body = () => {
        const section = this.state.section.item;
        if (!section.title?.length)
            return this.render_SubSections();
        return _jsxs(_Fragment, { children: [this.render_SectionContent(), this.render_SubSections()] });
    };
    render_SectionContent = () => {
        const section = this.state.section;
        const contentKey = exists(section.item.aiContent) ? 'aiContent' : 'content';
        //If no content to show
        if (!section.item[contentKey])
            return;
        //Show un-editable content
        if (!this.state.editMode)
            return _jsx("p", { className: 'smart-note-section__content', children: section.item[contentKey] });
        //Show editable content
        return _jsx(DefaultEditor_TextArea, { editable: this.state.section, prop: contentKey, disabled: this.state.parentDisabled || !this.state.section.item.isSelected, componentRef: this.textAreaRef, resizeWithText: true });
    };
    render_SubSections = () => {
        const subSections = this.state.section.editProp('subSections', []);
        if (!subSections.item.length)
            return;
        return _jsx(Grid, { className: 'smart-note-section__sub-sections', children: subSections.item.map((subSection, index) => {
                const editable = subSections.editProp(index, {});
                return _jsx(Component_SmartNoteSection, { section: editable, editMode: this.state.editMode, aiMode: this.state.aiMode, parentDisabled: this.state.parentDisabled || !this.state.section.item.isSelected }, index);
            }) });
    };
    render_Checkbox = () => {
        const section = this.state.section;
        if (!this.state.editMode || !section.item.isSelectable)
            return;
        const Icon = section.item.isSelected ? ICONS.v : ICONS.advisor_v5_minus;
        return _jsx(TS_Checkbox, { checked: section.item.isSelected, onCheck: this.toggleSectionSelection, icon: _jsx(Icon.component, {}) });
    };
}
//# sourceMappingURL=Component_SmartNoteSection.js.map